// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './Main/Dashboard';
import TextToPDF from './components/TextToPDF';
import MergePDFs from './components/MergePDFs';
import ImageToPDF from './components/ImageToPDF';
// import PdfToWord from 'pdfjs-dist/build/PdfToWord';

import SplitPDF from './components/SplitToPDF';
import PdfCompressor from './components/PdfCompressor';

import PdfCropperFixed from './components/PdfCropperFixed';
import PdfAddPageNumbers from './components/PdfpageToNumbers';
import PdfDeletePages from './components/PdfDeletePages';
import ExcelToPdf from './components/ExcelToPDF';
import ExcelSheetsToPdf from './components/ExcelsheetsToPDF';
import EditPDF from './components/EditPDF';
import PDFEditor from './components/PDFEditor';
import PrivacyPolicy from './components/PrivacyPolicy';
import Contact from './components/Contact';
import WatermarkPdf from './components/WatermarkPdfComponent';
import About from './components/About';
import Terms from './components/Terms';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import FAQs from './components/FAQs';
import Blog from './components/Blog';

function App() {
  return (
    <Router>
      <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/text-to-pdf" element={<TextToPDF />} />
        <Route path="/merge-pdfs" element={<MergePDFs />} />
        <Route path="/image-to-pdf" element={<ImageToPDF />} />
        {/* <Route path="/pdf-to-word" element={<PdfToWord />} /> */}
        <Route path="/SplitPDF" element={<SplitPDF />} />
        <Route path="/compress-pdf" element={<PdfCompressor />} />
         <Route path="/watermark-pdf" element={<WatermarkPdf />} />
         <Route path="/watermarkPdf" element={<WatermarkPdf />} />
         <Route path="/pdf-cropper-fixed" element={<PdfCropperFixed />} />
         <Route path="/add-page-numbers" element={<PdfAddPageNumbers />} />
         <Route path="/delete-pages" element={<PdfDeletePages />} />
         <Route path="/excel-to-pdf" element={<ExcelToPdf />} />
         <Route path="/excelsheets-to-pdf" element={<ExcelSheetsToPdf />} />
         <Route path="/edit-pdf" element={<EditPDF />} />
         <Route path="/pdf-editor" element={<PDFEditor />} />
  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
  <Route path="/contact" element={<Contact />} />
  <Route path="/about" element={<About />} />
  <Route path="/terms" element={<Terms />} />
  <Route path="/features" element={<Features />} />
  <Route path="/how-it-works" element={<HowItWorks />} />
  <Route path="/faqs" element={<FAQs />} />
   <Route path="/blog" element={<Blog />} />
      </Routes>
      </Layout>
    </Router>
  );
}

export default App;
